import { getCategoryNameFromId } from "owa-categories/lib/utils/categoryIdNameConverter";
import getMasterCategoryList from "owa-categories/lib/utils/getMasterCategoryList";
import { getListViewTypeForFolder } from "owa-mail-folder-store";
import type { TableQuery } from "owa-mail-list-store";
import type FocusedViewFilter from "owa-service/lib/contract/FocusedViewFilter";
import folderNameToId from "owa-session-store/lib/utils/folderNameToId";
import createMailFolderTableQuery from "./createMailFolderTableQuery";
import type { MailboxInfo } from "owa-client-types";

/**
 * Create the table query to load a category search folder
 * @param categoryId the id of the category
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailCategoryFolderTableQuery(categoryId: string, mailboxInfo: MailboxInfo): TableQuery {
    const categoryName = getCategoryNameFromId(categoryId, getMasterCategoryList(mailboxInfo));
    const mailCategoryTableQuery = createMailFolderTableQuery(folderNameToId("msgfolderroot", mailboxInfo), getListViewTypeForFolder(undefined), "category", -1, "UserCategory", categoryName);
    
    return mailCategoryTableQuery;
}
